import Mutations from "./status-page-mutations";
import Actions from "./status-page-actions";
import Getters from "./status-page-getters";
import DefaultState from "./status-page-default-state";
const store = {
  namespaced: true,
  state: DefaultState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default store;